import type {FC} from 'react';
import {CommonLink} from '../../../shared/components/CommonLink';

type Props = {
  textClassName: string;
  linkClassName: string;
};

export const RegisterTocLegacy: FC<Props> = ({
  textClassName,
  linkClassName,
}) => {
  return (
    <>
      <p className={`${textClassName} text-left`}>◆1.会員登録について◆</p>
      <ul className={`${textClassName} text-left`}>
        <li>
          1-1.
          <CommonLink href="#a1" className={linkClassName}>
            会員登録をしたい
          </CommonLink>
        </li>
        <li>
          1-2.
          <CommonLink href="#a2" className={linkClassName}>
            会員登録したいが大学発行のメールアドレスを持っていない
          </CommonLink>
        </li>
        <li>
          1-3.
          <CommonLink href="#a3" className={linkClassName}>
            新規会員登録画面で、大学発行のメールアドレスを入力したが、「そのメールアドレスはすでに登録されています」と表示される
          </CommonLink>
        </li>
        <li>
          1-4.
          <CommonLink href="#a4" className={linkClassName}>
            新規会員登録画面で、大学発行のメールアドレスを入力したが、本登録用URLが記載されたメールが届かない
          </CommonLink>
        </li>
        <li>
          1-5.
          <CommonLink href="#a5" className={linkClassName}>
            いつも使うメールアドレスの認証をしたいがログインできない
          </CommonLink>
        </li>
        <li>
          1-6.
          <CommonLink href="#a6" className={linkClassName}>
            既卒だが会員登録をしたい
          </CommonLink>
        </li>
      </ul>
    </>
  );
};
